"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import {parse, format, CountryCode} from 'libphonenumber-js';
var hashers_1 = require("./hashers");
var validators_1 = require("./validators");
function sanitizeEmailInText(text) {
    var emailRegex = /(\w+[^\s]*)@(\w+\.\w+)/g;
    return text.replace(emailRegex, function (match, username, provider) { return hashers_1.hashEmail(username, provider); });
}
/**
 * Sanitizes an email.
 *
 * @param email email to sanitize
 */
function sanitizeEmail(email) {
    if (!validators_1.validateEmail(email)) {
        return email;
    }
    return sanitizeEmailInText(email);
}
exports.sanitizeEmail = sanitizeEmail;
/**
 * Sanitizes a phone number.
 *
 * @param phone phone to sanitize
 */
function sanitizePhone(phone) {
    if (!validators_1.validatePhone(phone)) {
        return phone;
    }
    var visiblePart = phone.substr(0, phone.length - hashers_1.PHONE_NUM_DIGITS_TO_HASH);
    var hiddenPart = phone.substr(visiblePart.length);
    return hashers_1.hashPhone(visiblePart, hiddenPart);
}
exports.sanitizePhone = sanitizePhone;
/**
 * Normalizes the phone number according to https://en.wikipedia.org/wiki/E.164 and sanitizes it.
 *
 * @param phone             phone to sanitize
 * @param phoneCountryCode  phone country code
 */
// export function normalizeAndSanitizePhone(phone: string, phoneCountryCode: CountryCode) {
//   const parsed = parse(phone, phoneCountryCode);
//   if (!parsed.phone) {
//     return phone;
//   }
//   const formatted = format(parsed, 'International_plaintext');
//   return sanitizePhone(formatted);
// }
/**
 * Sanitizes text that might contain PII values.
 * Currently removes email addresses.
 *
 * @param text text to sanitize
 */
function sanitizePII(text) {
    if (!validators_1.validateString(text)) {
        return text;
    }
    var res = sanitizeEmailInText(text);
    return res;
}
exports.sanitizePII = sanitizePII;
//# sourceMappingURL=sanitizers.js.map